import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom"; // Remove BrowserRouter from here

import "./index.css";
import "./App.css";

import Header from "./components/Header";
import Hero from "./components/Hero";
import TrendingCampaigns from "./components/TrendingCampaigns";
import LiveDonations from "./components/LiveDonations";
import Features from "./components/Features";
import Categories from "./components/Categories";
import GlobalSection from "./components/GlobalSection";
import WhyChooseUs from "./components/WhyChooseUs";
import AboutSection from "./components/AboutSection";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import AboutPage from "./components/AboutPage";
import Campaigndetailspage from "./pages/campaigns_details";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.title = "GiveSendGo - The Leader in Online Fundraising";

    // Add meta description only once
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.content =
      "GiveSendGo exists to share the hope of Jesus Christ with the world by providing a free platform for Christians to raise money for causes they care about.";

    const timer = setTimeout(() => setIsLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-100 to-white">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-teal-600 font-semibold">Loading GiveSendGo...</p>
        </div>
      </div>
    );
  }

  return (
    // REMOVED BrowserRouter wrapper - it's already in index.js
    <div className="App min-h-screen flex flex-col bg-white">
      {/* GLOBAL HEADER */}
      <Header />

      {/* ROUTES */}
      <main className="flex-grow">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />
                <TrendingCampaigns />
                <LiveDonations />
                <Features />
                <Categories />
                <GlobalSection />
                <WhyChooseUs />
                <AboutSection />
                <Testimonials />
              </>
            }
          />

          {/* ABOUT PAGE */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/campaignsdetails" element={<Campaigndetailspage/>}/>
        </Routes>
      </main>

      {/* GLOBAL FOOTER */}
      <Footer />
    </div>
  );
}

export default App;